const LogoIcon = ({ className = "" }: { className?: string }) => (
  <svg
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Art Experto logo"
  >
    <defs>
      <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F5D98B" />
        <stop offset="35%" stopColor="#C9922A" />
        <stop offset="65%" stopColor="#E8C96A" />
        <stop offset="100%" stopColor="#A0721A" />
      </linearGradient>
      <linearGradient id="goldGrad2" x1="100%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#F5D98B" />
        <stop offset="50%" stopColor="#D4A832" />
        <stop offset="100%" stopColor="#8B5E1A" />
      </linearGradient>
      <filter id="glow">
        <feGaussianBlur stdDeviation="1.5" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    {/* Outer decorative diamond ring */}
    <path
      d="M50 4 L96 50 L50 96 L4 50 Z"
      stroke="url(#goldGrad)"
      strokeWidth="1.2"
      fill="none"
      opacity="0.5"
    />

    {/* Inner subtle diamond */}
    <path
      d="M50 14 L86 50 L50 86 L14 50 Z"
      stroke="url(#goldGrad)"
      strokeWidth="0.6"
      fill="none"
      opacity="0.25"
    />

    {/* Corner accent marks */}
    <line x1="50" y1="4" x2="50" y2="10" stroke="url(#goldGrad)" strokeWidth="1.5" opacity="0.8" />
    <line x1="50" y1="90" x2="50" y2="96" stroke="url(#goldGrad)" strokeWidth="1.5" opacity="0.8" />
    <line x1="4" y1="50" x2="10" y2="50" stroke="url(#goldGrad)" strokeWidth="1.5" opacity="0.8" />
    <line x1="90" y1="50" x2="96" y2="50" stroke="url(#goldGrad)" strokeWidth="1.5" opacity="0.8" />

    {/* A letter — elegant serif-style */}
    <g filter="url(#glow)">
      {/* A: left stroke */}
      <path
        d="M28 72 L38 28 L42 28 L50 58"
        stroke="url(#goldGrad)"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* A: right stroke (shared stem with E) */}
      <path
        d="M50 58 L56 28 L60 28 L50 58"
        stroke="url(#goldGrad2)"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* A: crossbar */}
      <line
        x1="33"
        y1="53"
        x2="49"
        y2="53"
        stroke="url(#goldGrad)"
        strokeWidth="2.2"
        strokeLinecap="round"
      />

      {/* E: vertical spine */}
      <line
        x1="56"
        y1="28"
        x2="56"
        y2="72"
        stroke="url(#goldGrad2)"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      {/* E: top bar */}
      <line
        x1="56"
        y1="28"
        x2="72"
        y2="28"
        stroke="url(#goldGrad2)"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      {/* E: middle bar */}
      <line
        x1="56"
        y1="50"
        x2="69"
        y2="50"
        stroke="url(#goldGrad2)"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      {/* E: bottom bar */}
      <line
        x1="56"
        y1="72"
        x2="72"
        y2="72"
        stroke="url(#goldGrad2)"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </g>

    {/* Tiny diamond dot separator between A and E */}
    <path
      d="M51 47 L53 50 L51 53 L49 50 Z"
      fill="url(#goldGrad)"
      opacity="0.7"
    />
  </svg>
);

export default LogoIcon;
